import { CHANGE_PROJECT, FETCH_SELECTED_GROUP, FETCH_SELECTED_PROJECT } from '@/store/common/mutation-type'
import { computed, getCurrentInstance, ref } from '@vue/composition-api'

function useSelectProjectAndGroup () {
    const vm = getCurrentInstance().proxy
    const store = vm.$store
    const projectTypeMap = computed(() => store.getters.projectTypeMap)
    const projects = computed(() => store.getters.projects)
    const projectIdxs = computed(() => store.getters.projectIdxs)
    const changeProject = computed(() => store.getters.changeProject)
    const internalUser = computed(() => store.getters.internalUser)
    const selectedGroup = computed(() => store.getters.selectedGroup)
    const accountGroups = computed(() => store.getters.accountGroups)
    const groupProjectMap = computed(() => store.getters.groupProjectMap)
    const selectedProject = computed(() => store.getters.selectedProject)
    const myOwnProjects = computed(() => store.getters.myOwnProjects)
    const additionalProjects = computed(() => store.getters.additionalProjects)
    const selectedMonth = computed(() => store.getters.selectedMonth)
    // select group option
    // const INIT_GROUP = {gi
    //     authority: '',
    //     childGroups: [],
    //     groupIdx: [],
    //     groupName: '',
    //     groupNamePath: `Select All Group  (${accountGroups.value.length})`,
    //     projects: []
    // }
    const groupSelectable = (option) => groupProjectMap.value[option.groupIdx].length
    const groupPlaceholder = computed(() => `${vm.$t('v4.Groups')} (${accountGroups.value.length})`)

    // select project option
    const createGroupOption = item => ({ type: 'group', label: `[${item.groupName}] ${item.projectName} - ${item.usageAccountId}`, ...item })
    const createMyProjectOption = item => ({ type: 'My Project', label: `[${vm.$t('v4.My Project')}] ${item.projectName} - ${item.usageAccountId}`, ...item })
    const createAdditionalProjectOption = item => ({ type: 'Additional Project', label: `[${vm.$t('v4.Additional Project')}] ${item.projectName} - ${item.usageAccountId}`, ...item })
    const myProjectOptions = computed(() => myOwnProjects.value.map(createMyProjectOption))
    const additionalProjectOpstion = computed(() => additionalProjects.value.map(createAdditionalProjectOption))
    const groupWithOptions = computed(() => {
        return (selectedGroup.value?.groupIdx
            ? groupProjectMap.value[selectedGroup.value.groupIdx].map(createGroupOption)
            : projects.value).map(createGroupOption)
    })
    const projectOptions = computed(() => {
        if (selectedGroup.value?.groupIdx) {
            return groupWithOptions.value
        } else {
            return [].concat(myProjectOptions.value).concat(groupWithOptions.value).concat(additionalProjectOpstion.value)
        }
    })
    const projectPlaceholder = computed(() => `${vm.$t('v4.Projects')} (${projectOptions.value.length})`)

    // model
    const projectModel = ref(selectedProject.value || null)
    const groupModel = ref(selectedGroup.value || null)

    // methods
    const handleSelectGroup = (value) => {
        if (value?.groupIdx) {
            if (store.getters.groupProjectMap[value.groupIdx].length === 0) {
                return null
            }
        }

        store.commit(FETCH_SELECTED_GROUP, value)
        if (!value) {
            if (!selectedProject.value) {
                store.commit(CHANGE_PROJECT, { event: 'all', value: null })
            } else {
                // store.commit(CHANGE_PROJECT, { event: 'project', value: selectedProject.value })
            }
            return
        }
        if (value?.groupIdx && selectedProject.value) {
            // 구현필요: 그룹을 선택했고 프로젝트가 선택되어 있을때, 프로젝트가 그룹에 속하면 상태변경을 할 필요가 없음.
            // 프로젝트 선택 상태가 유지되어야 함
            store.commit(FETCH_SELECTED_PROJECT, null)
        }
        store.commit(CHANGE_PROJECT, { event: 'group', value })
    }
    const handleSelectProject = (value) => {
        store.commit(FETCH_SELECTED_PROJECT, value)
        if (!value) {
            if (!selectedGroup.value?.groupIdx) {
                store.commit(CHANGE_PROJECT, { event: 'all', value: null })
            } else {
                store.commit(CHANGE_PROJECT, { event: 'group', value: selectedGroup.value })
            }
            return
        }
        if (value === null) {
            // console.error('need debug')
        }
        store.commit(CHANGE_PROJECT, { event: 'project', value })
    }
    const handleClearGroup = () => handleSelectGroup(null)
    const handleClearProject = () => handleSelectProject(null)
    // initial data
    const initialProject = computed(() => store.getters.initialProject)
    const selectGroup = (value) => store.commit(FETCH_SELECTED_GROUP, value)
    const selectProject = (value) => store.commit(FETCH_SELECTED_PROJECT, value)

    const setInitialAccountSelect = (all) => {
        if (all && !internalUser.value) return
        selectGroup(null)
        selectProject(initialProject.value)
        store.commit(CHANGE_PROJECT, { event: 'project', value: initialProject.value })
    }

    // qtype
    const qtypeParam = computed(() => {
        const params = {
            qtype: changeProject.value.event
        }
        if (!internalUser.value && params.qtype === 'all') {
            return params
        } else if (params.qtype === 'group') {
            params.groupIdx = [selectedGroup.value?.groupIdx]
            return params
        } else if (params.qtype === 'project') {
            params.projectIdx = [selectedProject.value?.projectIdx]
            return params
        } else {
            // console.error('Invalid project selection condition.')
            setInitialAccountSelect()
            return qtypeParam.value
        }
    })
    const isClearable = (cmp, cmpArr) => {
        if (cmp === 'common-select-group') {
            if (internalUser.value) {
                return cmpArr.includes('common-select-project') && !!selectedProject.value?.projectIdx
            } else {
                return true
            }
        }
        if (cmp === 'common-select-project') {
            if (internalUser.value) {
                return cmpArr.includes('common-select-group') && !!selectedGroup.value?.groupIdx
            } else {
                return vm.$route.name === 'summary' || cmpArr.includes('common-select-group') || (!cmpArr.includes('common-select-group') && cmpArr.indexOf('year') > -1 && cmpArr.indexOf('month') > -1)
            }
        }
        return false
    }

    // estimated
    const estimated = computed(() => selectedMonth.value === store.getters.months[0] && new Date().getMonth() === (Number(selectedMonth.value.substring(5, 7)) - 1))

    return {
        // common
        internalUser,
        groupProjectMap,
        projectTypeMap,
        changeProject,
        isClearable,
        selectGroup,
        selectProject,
        setInitialAccountSelect,
        estimated,
        qtypeParam,
        // group
        selectedGroup,
        groupModel,
        groupOptions: accountGroups,
        groupPlaceholder,
        groupSelectable,
        handleSelectGroup,
        handleClearGroup,
        accountGroups,

        // project
        selectedProject,
        projectModel,
        projectOptions,
        projectPlaceholder,
        projects,
        projectIdxs,
        handleSelectProject,
        handleClearProject
    }
}

export default useSelectProjectAndGroup
